import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCategoryRelatedSearches } from '@/redux/modules/categoryRelatedSearches';
import { fetchItemCarouselsIfNeeded } from '@/redux/modules/itemCarousel/itemCarousel.actions';
import { fetchItemFacetsIfNeeded } from '@/redux/modules/itemFacets';
import { fetchItemSummaries } from '@/redux/modules/item/summary/itemSummary.actions';
import { getCarousels } from '@/redux/modules/itemCarousel/itemCarousel.selectors';
import { getItemIdFromPath } from '@/utils/urls';
import { getPriceResults, getPriceResultsData } from '@/redux/modules/priceResults/priceResults.actions';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';

export const priceResultPageData = async ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;
    const slug = params.slugId;
    const slugItemId = getItemIdFromPath(`/item/${slug}`);
    const loggedIn = isUserLoggedIn(getState());

    // Always fetch price result meta (lotId, slug, etc.). Sales history only when logged in.
    const priceResultDataPromises = [dispatch(getPriceResultsData(slug))];
    if (loggedIn) {
        priceResultDataPromises.push(dispatch(getPriceResults({ slug })));
    }
    const priceResultData = await Promise.all(priceResultDataPromises);

    const itemId = priceResultData[0]?.payload?.lotId ?? (slugItemId || 0);
    const salesHistoryItemsItemIds =
        priceResultData[1]?.payload?.salesHistoryItems?.map((item: { itemId: number }) => item.itemId) || [];

    const promises = [];
    if (itemId) {
        promises.push(dispatch(fetchItemFacetsIfNeeded([itemId])));
        promises.push(
            dispatch(
                fetchItemSummaries({
                    force: true,
                    identifier: 'price-results-page',
                    itemIds: [itemId],
                    similarItems: true,
                })
            )
        );
        // Fetch carousel data first UseNewSimilarItems is always true
        await dispatch(fetchItemCarouselsIfNeeded({ itemId, useNewSimilarItems: true }));

        // Now fetch item summaries for carousel items
        const state = store.getState();
        const carousels = getCarousels(state, itemId);
        const carouselItemIds: number[] = [];

        carousels.forEach((carousel) => {
            if (carousel.itemIds && carousel.itemIds.length > 0) {
                carouselItemIds.push(...carousel.itemIds);
            }
        });

        if (carouselItemIds.length > 0) {
            promises.push(
                dispatch(
                    fetchItemSummaries({
                        identifier: 'price-results-carousel-items',
                        itemIds: carouselItemIds,
                    })
                )
            );
        }
    }
    promises.push(dispatch(fetchCategoryRelatedSearches([...salesHistoryItemsItemIds])));
    await Promise.all(promises);

    return Promise.resolve();
};
